<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>

        <v-alert  :value="true"  v-if="error != null" type="error" v-html="error.message"></v-alert>

        <v-layout justify-center column>

          <v-form ref="form" v-model="valid" @submit="signUp">
            
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="firstName" :rules="firstNameRules" label="First name *" required ></v-text-field>
              </v-flex>

              <v-flex xs12 pb-0>
                <v-text-field outline v-model="lastName" :rules="lastNameRules" label="Last name *"  required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="username" :rules="usernameRules" type="email" label="Email address *" required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="usernameConfirm" :rules="confirmUsernameRules" type="email" label="Confirm email address *" required ></v-text-field>
              </v-flex>
            </v-layout>

             <v-layout row>
                <v-flex xs12 sm2>Date of birth*</v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    :items="days"
                    label="DD"
                    v-model="dobDay"
                    required
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3 >
                  <v-select
                    :items="months"
                    label="MM"
                    v-model="dobMonth"
                    outline
                    required
                  ></v-select>
                  </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    :items="years"
                    label="YYYY"
                    v-model="dobYear"
                     :rules="dobValidation"
                    outline
                    required
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs3 pb-0>
                  <v-select
                    :hide-details="true"
                    label="Phone country"
                    :items="countries"
                    item-value="code"
                    v-model="phoneCountry"
                    outline
                    required
                  >
                    <template slot="selection" slot-scope="data">
                      <!-- HTML that describe how select should render selected items -->
                      +{{ data.item.phoneCode }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.name }} (+{{
                        data.item.phoneCode
                      }})
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs9>
                  <v-text-field
                    outline
                    v-model="phoneNumber"
                    :rules="phoneRules"
                    label="Mobile phone number *"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>


            <v-layout row>
              <v-flex xs12 pb-0>
                <v-select
                  outline
                  :items="countries"
                  v-model="country"
                  item-text="name"
                  :rules="countryRules"
                  label="Country *"
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline ref="pass" v-model="pass" :rules="passRules" label="Password *" type="password" required ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field outline ref="passConfirm" v-model="passConfirm" :rules="passConfirmRules" label="Confirm password *"  type="password"  required></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <p class="password-notice">A valid password must contain one upper case letter, one lower case letter, a number and a special character (e.g. ^ $ * . ! @ # % &amp;) and also must be at least 8 characters in length.</p>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <p>Our <a :href="configStrings.clubPrivacyPolicyLink" target="_blank">EFL Website Privacy Policy</a> sets out details about how we use your information.</p>
                <v-switch
                  :label="`Please tick this box if you do want EFL to send you more emails or texts with offers and other promotional information relating to Fantasy EFL.`"
                  v-model="commsOptIn"
                  color="#001C3C"
                ></v-switch>
                </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <h3 class="heading-3">Communication preferences</h3>
              </v-flex>
            </v-layout>

            <v-layout col>
              <v-flex xs12 pb-0>
                Do you want to hear from your Club and the EFL Group about the latest information relating to them and their partners including news, products, offers, competitions, community and charity activities, services & events?
                <v-tooltip right>
              <template #activator="{ on, attrs }">
                <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                >
                  info
                </v-icon>
              </template>
              <span>Your Club and/or its Club charities, as well as the<br /> EFL Group (EFL, EFL Digital & EFL in the Community) <br />and Club and EFL Group partners (existing & future) may communicate <br /> with you by email, SMS, automated phone calls or online direct <br />messages. Your preferences can be tailored by clicking more options. <br /> You’ll always be able to update your communication preferences <br /> whenever we contact you. If you no longer wish to receive information <br />from your Club after you sign up, you will have to contact the Club directly.</span>
            </v-tooltip>
              </v-flex>
            </v-layout>

            <v-radio-group v-model="generalOptIn" :column="false" :rules="generalOptInRules">
              <v-radio
                  color="#001C3C"
                  label="Yes"
                  value="yes"
              />
              <v-radio
                  color="#001C3C"
                  label="No"
                  value="no"
              />
              <v-radio
                  color="#001C3C"
                  label="More options"
                  value="more"
              />
            </v-radio-group>
            <template v-if="generalOptIn === 'more'">

            <h3>Content sent from your Club
              <v-tooltip right>
              <template #activator="{ on, attrs }">
                <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                >
                  info
                </v-icon>
              </template>
              <span>{{ EFLClubInfoText }}</span>
            </v-tooltip>
            </h3>

            <v-switch
                v-model="ClubNewsletterOptIn"
                color="#001C3C"
                @change="validateCommsMethods; validateCommsMethods()"
            >
              <template v-slot:label>Newsletter</template>
            </v-switch>

            <p>A weekly round-up including news, information, products, offers, competitions, community and charity activities, services, events & updates about your club and its partners.
              <v-tooltip right>
              <template #activator="{ on, attrs }">
                <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                >
                  info
                </v-icon>
              </template>
              <span>{{EFLPartnersInfoTextAlternate}}</span>
            </v-tooltip></p>

            <v-switch
                v-model="ClubNewsOptIn"
                color="#001C3C"
                @change="validateCommsMethods; validateCommsMethods()"
            >
              <template v-slot:label>News, products & offers</template>
            </v-switch>

            <p>Latest news & information about your club and its partners
              <v-tooltip right>
                <template #activator="{ on, attrs }">
                  <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                  >
                    info
                  </v-icon>
                </template>
                <span>{{EFLPartnersInfoTextAlternate}}</span>
              </v-tooltip>, as well as updates on products, offers, competitions, community and charity activities, services & events.</p>
            </template>

            <template v-if="generalOptIn === 'more'">
              <h3>Content sent from EFL Group
                <v-tooltip right>
                  <template #activator="{ on, attrs }">
                    <v-icon
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                    >
                      info
                    </v-icon>
                  </template>
                  <span>{{EFLConsentInfoText}}</span>
                </v-tooltip>
              </h3>

              <v-switch
                  v-model="EFLNewsletterOptIn"
                  color="#001C3C"
                  @change="validateCommsMethods; validateCommsMethods()"
              >
                <template v-slot:label>Newsletter</template>
              </v-switch>

              <p>
                A weekly round-up including news, information, products, offers, competitions, community and charity activities, services, events & updates about the EFL Group and its partners.
                <v-tooltip right>
                <template #activator="{ on, attrs }">
                  <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                  >
                    info
                  </v-icon>
                </template>
                <span>{{EFLPartnersInfoText}}</span>
              </v-tooltip></p>

              <v-switch
                  v-model="EFLNewsOptIn"
                  color="#001C3C"
                  @change="validateCommsMethods; validateCommsMethods()"
              >
                <template v-slot:label>News, products & offers</template>
              </v-switch>
            <p>Latest news & information about EFL Group and its partners
              <v-tooltip right>
                <template #activator="{ on, attrs }">
                  <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                  >
                    info
                  </v-icon>
                </template>
                <span>{{EFLPartnersInfoText}}</span>
              </v-tooltip>, as well as updates on products, offers, competitions, community and charity activities, services & events.</p>
            </template>

            <p v-if="optedInToAny === true">How do you want to hear from your Club and/or the EFL Group?*</p>
            <p v-if="commsMethodMessage"  style="color: red;">{{this.commsMethodMessage}}</p>
            <v-layout row wrap v-if="optedInToAny === true">
                <v-flex xs12 lg2 mt-0 pt-0 pb-0>
                  <v-switch
                  id="commsMethodEmail"
                  :label="`Email`"
                  v-model="commsMethodEmail"
                  :rules="commsMethodValidation"
                  @change="validateCommsMethods"
                  color="#001C3C"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 lg2 pt-0 pb-0>
                  <v-switch
                  id="commsMethodSMS"
                  :label="`SMS`"
                  v-model="commsMethodSMS"
                  :rules="commsMethodValidation"
                  @change="validateCommsMethods"
                  color="#001C3C"
                  ></v-switch> 
                </v-flex>
                <v-flex xs12 lg3 pt-0 pb-0>
                  <v-switch mb-auto
                  id="commsMethodPhone"
                  :label="`Automated phone calls`"
                  v-model="commsMethodPhone"
                  :rules="commsMethodValidation"
                  @change="validateCommsMethods"
                  color="#001C3C"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 lg5 mb-0 pt-0 pb-0>
                  <v-switch
                    id="commsMethodDM"
                    @change="validateCommsMethods"
                    :rules="commsMethodValidation"
                    v-model="commsMethodDM"
                    color="#001C3C"
                  >
                    <template #label>
                      <div class="d-flex align-center">
                        Online direct messages
                        <v-tooltip right>
                          <template #activator="{ on, attrs }">
                            <v-icon
                              class="ml-2"
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                            >
                              info
                            </v-icon>
                          </template>
                          <span>{{ EFLOnlineDirectMessageInfoText }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-switch>
                </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pt-0 pb-1>
                <v-switch
                  id="termsSwitch"
                  v-model="termsAgree"
                  :rules="termsAgreeRules"
                  color="#001C3C"
                ><template v-slot:label>I agree to the&nbsp;<a href="https://www.efl.com/terms-and-conditions/fantasy-efl/" target="_blank"> Fantasy EFL Terms &amp; Conditions</a>.*</template></v-switch>
              </v-flex>
            </v-layout>

    

            <v-layout row align-center mx-1 py-0>
              <router-link to="/" class="text-button">Already registered?</router-link>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid">Register</button>
            </v-layout>

          </v-form>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import { parsePhoneNumber } from 'awesome-phonenumber'
export default {
  name: 'Registration',

  components: {
    'tooltip': () => import('./Tooltip.vue')
  },
  
  data () {
    
    return {
      valid: true,
      firstNameRules: [
        v => !!v || 'First name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last name is required'
      ],
      countryRules: [
        v => !!v || 'Country is required'
      ],
      dobRules: [
        v => !! v || 'Date of birth is required',
        v => (this.dobYear+'-'+("0" + this.dobMonth).slice(-2)+'-'+("0" + this.dobYear).slice(-2)).toString() < new Date().toISOString().split('T')[0] || "Date can't be in the future"
      ],
      dobValidation: ['You must enter a date of birth'],
      commsMethodValidation: ['You must select at least one communication method'],
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        v => /.*[a-z].*/.test(v) || 'Password must contain at least one lower case letter',
        v => /.*[A-Z].*/.test(v) || 'Password must contain at least one upper case letter',
        v => /\d/.test(v) || 'Password must contain at least one number',
        v => /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) || 'Password must contain at least one special character (e.g. ^ $ * . ! @ # % &)',
        v => (this.passConfirm.length >=8 && v == this.passConfirm) || 'Password confirmation must match password'
      ],
      passConfirmRules: [
        v => (v == this.pass) || 'Password confirmation must match password'
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => (!v || /*v.length < 3 ||*/ /.+@.+/.test(v)) || 'Username must be a valid email',
        v => (!v || !v.includes(' ')) || 'An email address cannot contain any spaces'
      ],
      generalOptInRules:  [v => !!v || 'You must select an option'],
      confirmUsernameRules: ['Email confirmation is required'],
      termsAgreeRules: [
        v => !!v || 'You must agree to continue'
      ],
      firstName: '',
      ssoid: '',
      lastName: '',
      username: '',
      usernameConfirm: '',
      phoneNumber: "",
      phoneCountry: "",
      phoneNormalised: "",
      pass: '',
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      country: '',

      //Old Opt Ins
      commsOptIn: false,
      clubOptIn: false,
      eflOptIn: false,
      clubPartnerOptIn: false,
      eflPartnerOptIn: false,

      //Old Opt In selection
      commsMethodEmail: false,
      commsMethodSMS: false,
      commsMethodPhone: false,
      commsMethodDM: false,
      commsEmailManuallyToggled: false,

      //Keep for logic support
      optedInToAny: false,
      termsAgree: false,
      passConfirm: '',
      error: null,
      loading: false,
      communicationString: 'Email',
      communicationStringLong: 'emails',
      commsMethodMessage: null,
      countries: [],
      days: [],
      months: [],
      years: [],

      //new Opt In
      generalOptIn: false,
      EFLNewsletterOptIn: false,
      EFLNewsOptIn: false,
      ClubNewsletterOptIn: false,
      ClubNewsOptIn: false,

      //opt in info text
      EFLServicesAndEventsInfoText: "Your Club and/or its Club charities, as well as the EFL Group (<a href='https://www.efl.com/about-the-efl/' target='_blank'>EFL</a>, <a href='https://www.efl.com/efl-digital-clubs-company-details/' target='_blank'>EFL Digital</a> & <a href='https://www.efl.com/community/' target='_blank'>EFL in the Community</a>) and Club and <a href='https://www.efl.com/commercial-partners/' target='_blank'>EFL Group partners</a> (existing & future) may communicate with you by email, SMS, automated phone calls or online direct messages. Your preferences can be tailored by clicking more options. You’ll always be able to update your communication preferences whenever we contact you. If you no longer wish to receive information from your Club after you sign up, you will have to contact the Club directly.",
      EFLOnlineDirectMessageInfoText: "By consenting to ‘Online direct messages’, you are permitting your Club and/or the EFL Group to direct message you via social media platforms.",
      EFLClubInfoText: "This means your Club and/or its Club charities.",
      EFLConsentInfoText: "This includes the EFL, EFL Digital & EFL in the Community.",
      EFLPartnersInfoText: "This means existing and future partners of the EFL Group.",
      EFLPartnersInfoTextAlternate: "This means existing and future partners of your Club."
    }
  },
  created () {

    if(this.configValues.accountRegistrationPreferencesAreEmailOnly === false){
      this.communicationString = 'Communication'
      this.communicationStringLong = 'communications (via email, sms, phone or mail)'
    }

    this.populateDates ()
    fetch("/countries.json")
      .then(r => r.json())
      .then(
        json => {
          this.countries = json.countries;
        },
        response => {
          console.log("Error loading json:", response);
        }
      );
  },
  computed: {
    phoneRules() {
      const pn = parsePhoneNumber( this.phoneNumber , { regionCode: this.phoneCountry});
      //console.log('Phone number is', pn.valid)
      if (!this.phoneNumber) {
        // console.log('Phone number Doesn\'t exist but it is OK on reg')
        return ['You must enter a phone number'];
      } else {
        // console.log('Phone number exists')
        return [() => pn.valid|| "Please ensure you have selected your phone country and entered the number correctly"];
      }
    }
  },
  watch: {
    pass: function (val, oldVal) {
      this.$refs.form.validate()
    },
    passConfirm: function (val, oldVal) {
      this.$refs.form.validate()
    },
    username: function (val, oldVal) {
      this.validateUsernameRules()
    },
    usernameConfirm: function (val, oldVal) {
      this.validateUsernameRules()
    },
    dobDay: function (val, oldVal) {
      console.log('Day changed')
      this.validateDateOfBirth()
    },
    dobMonth: function (val, oldVal) {
      console.log('Month changed')
      this.validateDateOfBirth()
    },
    dobYear: function (val, oldVal) {
      console.log('Year changed')
      this.validateDateOfBirth()
    },
    clubOptIn: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    clubPartnerOptIn: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    eflOptIn: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    eflPartnerOptIn: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    commsMethodEmail: function (val, oldVal) {
      if (!val) {
          this.commsEmailManuallyToggled = true
      }
      this.validateCommsMethods()
    },
    commsMethodPhone: function (val, oldVal) {
      this.validateCommsMethods()
    },
    commsMethodSMS: function (val, oldVal) {
      this.validateCommsMethods()
    },
    commsMethodDM: function (val, oldVal) {
      this.validateCommsMethods()
    },
    ClubNewsOptIn: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    ClubNewsletterOptIn: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    EFLNewsOptIn: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    EFLNewsletterOptIn: function (val, oldVal) {
      this.checkOptIns()
      this.validateCommsMethods()
    },
    generalOptIn: function (val, oldVal) {
      this.checkOptIns()
      this.$nextTick(() => {
        this.validateCommsMethods()
      })
    }
  },
  methods: {
    checkOptIns() {
      const hasSpecificOptIn = this.ClubNewsOptIn || this.ClubNewsletterOptIn || this.EFLNewsOptIn || this.EFLNewsletterOptIn

      if (this.generalOptIn === "no") {
        this.optedInToAny = false
        this.commsMethodEmail = false
        this.commsMethodPhone = false
        this.commsMethodSMS = false
        this.commsMethodDM = false
        this.ClubNewsOptIn = false
        this.ClubNewsletterOptIn = false
        this.EFLNewsOptIn = false
        this.EFLNewsletterOptIn = false
        return
      }

      if (this.generalOptIn === "yes") {
        //all communication options default true
        this.optedInToAny = false
        this.commsMethodEmail = true
        this.commsMethodPhone = true
        this.commsMethodSMS = true  
        this.commsMethodDM = true  
        //reset
        this.ClubNewsOptIn = false
        this.ClubNewsletterOptIn = false
        this.EFLNewsOptIn = false
        this.EFLNewsletterOptIn = false
        return
      } 
      
      if (this.generalOptIn === "more" && hasSpecificOptIn) {
        this.commsMethodEmail = true
        this.optedInToAny = true

        //reset communication options
        this.commsMethodPhone = false
        this.commsMethodSMS = false  
        this.commsMethodDM = false  
        return
      }
    },
    validateUsernameRules() {
      if(this.username === this.usernameConfirm){
          this.confirmUsernameRules = [true]

        }else{
          this.confirmUsernameRules = ['Email and confirmation do not match']
      }
    },
    validateCommsMethods() {
        const hasCommsSelected = this.commsMethodEmail || this.commsMethodPhone || this.commsMethodSMS || this.commsMethodDM
        const hasOptInSelected = this.ClubNewsOptIn || this.ClubNewsletterOptIn || this.EFLNewsOptIn || this.EFLNewsletterOptIn

        if (this.generalOptIn === "no") {
            this.commsMethodValidation = [true]
            this.commsMethodMessage = null
            return
        }

        if (this.generalOptIn === "more") {

          if (!hasOptInSelected) {
              this.commsMethodValidation = ["You must select at least one opt-in option"]
              this.commsMethodMessage = "You must select at least one opt-in option"
              this.valid = false
              return
          }

          if (!hasCommsSelected) {
              this.commsMethodValidation = ["You must select at least one method of communication"]
              this.commsMethodMessage = "You must select at least one method of communication"
              this.valid = false
              return 
          }

          this.commsMethodValidation = [true]
          this.commsMethodMessage = null
          return 
        }

        if (this.generalOptIn === "yes" && !hasCommsSelected) {
            this.commsMethodValidation = ["You must select at least one method of communication"]
            this.commsMethodMessage = "You must select at least one method of communication"
        } else {
            this.commsMethodValidation = [true]
            this.commsMethodMessage = null
        }
    },
    validateDateOfBirth() {
      // Validate date of birth fields only if all three are filled
      if (this.dobYear && this.dobMonth && this.dobDay) {

        // Optionally, you can also run the custom validation rule for date of birth
        const isValidDateOfBirth = this.isValidDate();

        var age = this.calculateAge(
            this.dobYear,
            this.dobMonth,
            this.dobDay
          ); // get age of the user based on the DoB fields


        if(isValidDateOfBirth){
          if(age < this.configValues.accountConsentAge){
            this.dobValidation = ['You must be at least '+ this.configValues.accountConsentAge +' years old.']
          }else{
            this.dobValidation = [true]
          }
        } else {
          this.dobValidation = ['Date of birth not valid']
        }
      }
      return false; // Date of birth is not fully entered yet
    },
    isValidDate() {
      const dateOfBirth = new Date(this.dobYear, this.dobMonth - 1, this.dobDay); // Month is 0-based
      const currentDate = new Date();
      return dateOfBirth <= currentDate;
    },
    pad (num, size) {
      var s = num+"";
      while (s.length < size) s = "0" + s;
      return s;
    },
    
    populateDates () {
      console.log('ADDING DATES')
      for(var d=1; d<32; d++){
        this.days.push(d)
      }
      for(var m=1; m<13; m++){
        this.months.push(m)
      }
      var thisYear = new Date().getFullYear()

      if(this.configValues.accountConsentRequired === true && this.configValues.accountConsentAge > 0){
        thisYear = thisYear - this.configValues.accountConsentAge
      }

      for(var y=thisYear+1; y > 1900 ; y--) {
        this.years.push(y)
      }
    },
    crmXCMPush(username){
      var crmXCMPushURL = process.env.VUE_APP_XCM_CRM_API+'/user/push/'+ username
      console.log('XCM push url', crmXCMPushURL)
      return axios({
        method: 'get',
        url: crmXCMPushURL
      })
    },
    complete(username){
      console.log('completing')
      var vm = this
      this.dataPush(username)
      .then(function (results) {
        console.log('redirecting after data push')
        //vm.$router.push("/post-registration-message");
        localStorage.registrationEmail = username
        vm.$router.push("/verify-and-login");
      });
    },
    signUp (e) {
        e.preventDefault()
        this.loading = true
        var email = this.username.toLowerCase()
        var password = this.pass
        var firstName = this.firstName
        var lastName = this.lastName
        var termsAgree = this.termsAgree.toString()
        
        var attributesList = {
            "given_name": firstName, 
            "family_name": lastName, 
            "custom:privacy_accepted": termsAgree
        }

        if (this.phoneNumber) {
          const pn = parsePhoneNumber( this.phoneNumber , { regionCode: this.phoneCountry});
          if(pn.valid === true){
            attributesList['phone_number'] = pn.number.e164
            // console.log('Saving phone', attributesList['phone_number'])
          }
        }

        var address = {
          country: this.country
        };

        attributesList["address"] = JSON.stringify(address);

        // if (this.eflOptIn.toString() === 'true') {
        //   attributesList['custom:comms_org'] = 'true'
        // } else {
        //   attributesList['custom:comms_org'] = 'false'
        // }
        //
        // //needs updating this sucks
        // if (this.commsOptIn.toString() === 'true') {
        //   attributesList['custom:comms_opt_in'] = 'true'
        // } else {
        //   attributesList['custom:comms_opt_in'] = 'false'
        // }
        //
        // if (this.clubOptIn.toString() === 'true') {
        //   attributesList['custom:comms_club'] = 'true'
        // } else {
        //   attributesList['custom:comms_club'] = 'false'
        // }
        //
        // if (this.clubPartnerOptIn.toString() === 'true') {
        //   attributesList['custom:comms_club_partner'] = 'true'
        // } else {
        //   attributesList['custom:comms_club_partner'] = 'false'
        // }
        //
        // if (this.eflPartnerOptIn.toString() === 'true') {
        //   attributesList['custom:comms_org_partner'] = 'true'
        // } else {
        //   attributesList['custom:comms_org_partner'] = 'false'
        // }
        if (this.EFLNewsOptIn.toString() === 'true' || this.generalOptIn === 'yes') {
          attributesList['custom:efl_news'] = 'true'
        } else {
          attributesList['custom:efl_news'] = 'false'
        }
        if (this.EFLNewsletterOptIn.toString() === 'true' || this.generalOptIn === 'yes') {
          attributesList['custom:efl_newsltr'] = 'true'
        } else {
          attributesList['custom:efl_newsltr'] = 'false'
        }
        if (this.ClubNewsOptIn.toString() === 'true' || this.generalOptIn === 'yes') {
          attributesList['custom:club_news'] = 'true'
        } else {
          attributesList['custom:club_news'] = 'false'
        }
        if (this.ClubNewsletterOptIn.toString() === 'true' || this.generalOptIn === 'yes') {
          attributesList['custom:club_newsltr'] = 'true'
        } else {
          attributesList['custom:club_newsltr'] = 'false'
        }


        if (this.commsMethodEmail.toString() === 'true') {
          attributesList['custom:comms_method_email'] = 'true'
        } else {
          attributesList['custom:comms_method_email'] = 'false'
        }

        if (this.commsMethodSMS.toString() === 'true') {
          attributesList['custom:comms_method_sms'] = 'true'
        } else {
          attributesList['custom:comms_method_sms'] = 'false'
        }

        if (this.commsMethodPhone.toString() === 'true') {
          attributesList['custom:comms_method_phone'] = 'true'
        } else {
          attributesList['custom:comms_method_phone'] = 'false'
        }

        if (this.commsMethodDM.toString() === 'true') {
          attributesList['custom:comms_method_dm'] = 'true'
        } else {
          attributesList['custom:comms_method_dm'] = 'false'
        }

        //END

       

        if(this.dobDay && this.dobMonth && this.dobYear){
          attributesList['birthdate'] = this.dobYear + '-' + this.pad(this.dobMonth, 2) + '-' + this.pad(this.dobDay, 2)
        }
        var vm = this
        this.$signUp(email, password, attributesList).subscribe((data) => {
            console.log("sign up successful, data:", data.user)
            var username = data.user.username
            vm.complete(username)
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err.message)
            if(err.message === 'An account with the given email already exists.'){
              err.message = 'This is an existing ' +this.configStrings.productName + ' account - <a href="/forgot-password" class="text-button--login-error">Please click here to reset your password</a>'
            }
            vm.error = err
        });

    }
  }
}
</script>

<style lang="scss" scoped>
  .password-notice {
    margin: 0 0 20px;
    padding: 0 0 40px;
    color: $core-grey;
    font-size: 15px;
    line-height: 22px;
    border-bottom: 1px solid $core-light-grey;
  }

  .heading-3{
    text-align: start;
  }

  .v-input--switch__track.theme--light.error--text {
    color: rgba(0,0,0,0.38) !important;
  }
  .v-input--selection-controls__ripple.error--text{
    color: $core-white !important;
  }
  .v-input--switch__thumb.theme--light.error--text{
    color:$core-lightest-grey !important;
  }

  .error {
    display: block;
  }
</style>